import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { LinkListComponent } from '../../../../../shared/components/molecules/link-list/link-list.component';
import { CmsFacade } from '../../../services/cms.facade';

@Component({
  selector: 'app-featured-links',
  standalone: true,
  imports: [LinkListComponent],
  templateUrl: './featured-links.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeaturedLinksComponent {
  private readonly facade = inject(CmsFacade);
  readonly categories = this.facade.featuredLinksCategories;
}
